module.exports = __webpack_public_path__ + "static/media/zcc.f327680f.jpg";